import { render, staticRenderFns } from "./companybill.vue?vue&type=template&id=040c959a&scoped=true&"
import script from "./companybill.vue?vue&type=script&lang=js&"
export * from "./companybill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c959a",
  null
  
)

export default component.exports